module.exports = __webpack_public_path__ + "img/c4.f7562e73.jpg";